import React, { useEffect, useState } from "react";
import BarTitle from "../../components/BarTitle";
import Painel from "../../components/Painel";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import Axios from "axios";
import constants from "../../constants";
import InputMask from "react-input-mask";
import swal from "sweetalert";
import * as XLSX from "xlsx";
import ReactAutocomplete from "react-autocomplete";

let initialSettingsDatePicker = {
  minDate: "01/01/2015",
  maxDate: moment(new Date()),
  opens: "left",
  locale: {
    applyLabel: "Aplicar",
    fromLabel: "De",
    format: "DD/MM/YYYY",
    toLabel: "à",
    separator: " à ",
    cancelLabel: "Cancelar",
    customRangeLabel: "Data Customizada",
    daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  },
  ranges: {
    Hoje: [moment(new Date())],
    Ontem: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Últimos 7 Dias": [moment().subtract(6, "days"), moment()],
    "Últimos 30 Dias": [moment().subtract(29, "days"), moment()],
    "Este Mês": [moment().startOf("month"), moment().endOf("month")],
    "Mês Passado": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  },
};

export default function FinancialReport() {
  const [startDate, setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment(new Date()).clone().add(1, "days").format("YYYY-MM-DD"));
  const [paymentSolicitation, setPaymentSolicitation] = useState([]);
  const [allDrivers, setAllDrivers] = useState([]);
  const [allEstablishments, setAllEstablishments] = useState([]);
  const [start_time, set_start_time] = useState(moment(new Date()).format("DD/MM/YYYY"));
  const [end_time, set_end_time] = useState(moment(new Date()).clone().add(1, "days").format("DD/MM/YYYY"));
  const [displayDate, setDisplayDate] = useState({});
  const [form_payment, setForm_payment] = useState('');
  const [status, setStatus] = useState([]);
  const [selectAll, setSelectAll] = useState([]);
  const [idCount, setIdCount] = useState(0);
  const [establishment, setEstablishment] = useState("");
  const [deliveryman, setDeliveryman] = useState("");
  const [documentData, setDocumentData] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [allDriversValue, setAllDriversValue] = useState("");
  const [driver_id, setDriver_id] = useState("");
  const [allEstablishmentValue, setAllEstablishmentsValue] = useState("");
  const [user_id, setUser_id] = useState("");
  const [totalList, setTotalList] = useState(0);
  const [totalTaxList, setTotalTaxList] = useState(0);
  const [allItems, setAllItems] = useState(0);

  useEffect(() => {
    // ACORDA HEROKU
    Axios.post("https://super-image-api.herokuapp.com/all-fast-report/").then(
      () => {}
    );
  }, []);

  useEffect(() => {
    if (localStorage.is_super_user == "false") {
      setUser_id(localStorage.id_establishment);
    }
  }, []);

  useEffect(() => {
    // ACORDA HEROKU
    const url =
      constants().URL_SERVICE + "establishment/establishment/get_drivers_list/";
    Axios.get(url, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {
        setAllDrivers(response.data.drivers);
      })
      .catch((error) => this.setState({ error: true }));
  }, []);

  useEffect(() => {
    // ACORDA HEROKU
    const url = constants().URL_SERVICE + "establishment/establishment/get_establishments_list/";
    Axios.get(url, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {
        setAllEstablishments(response.data.establishments);
      })
      .catch((error) => this.setState({ error: true }));
  }, []);

  function convertValue(_value){
    let value = Number(_value).toFixed(2);
    return parseFloat(value);
    //return parseFloat(_value).toFixed(2).replaceAll('.', ',');
  }

  function handleEvent(event, picker){
    set_start_time(picker.startDate.format("DD/MM/YYYY"));
    set_end_time(picker.endDate.format("DD/MM/YYYY"));
    setDisplayDate({
      start_time: picker.startDate.format("DD/MM/YYYY"),
      end_time: picker.endDate.format("DD/MM/YYYY"),
    });
  }

  function handleGetFinancials(params){
    let data = { start_time, end_time, status, driver_id, user_id, form_payment };
    const url = constants().URL_SERVICE + "establishment/establishment/get_report_financial/";

    setShowLoading(true);

    Axios.post(url, data, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {

        setShowLoading(false);
        setPaymentSolicitation(response.data.report);

        /* make the worksheet */
        const allNamesAndPrice = [];
        const container = [];
        let allPrice = 0;
        let allPriceDriver = 0;
        let allPriceUser = 0;
        let finalAllPriceNoTax = 0;
        let allPriceNoTax = 0;
        let allPriceNoTaxUser = 0;
        let driverId = 0;
        let userId = 0;

        container.push({ Datas: "Data inicial: " + start_time});
        container.push({ Datas: "Data final: " + end_time});
        
        if (selectAll == 2) {
          response.data.report.sort((a, b) =>
            a.driver_id == b.driver_id ? 0 : a.driver_id > b.driver_id ? 1 : -1
          );
          response.data.report.sort((a, b) =>
            a.driver == b.driver ? 0 : a.driver > b.driver ? 1 : -1
          );
        } 
        else if (selectAll == 1) {
          response.data.report.sort((a, b) =>
            a.user_id == b.user_id ? 0 : a.user_id > b.user_id ? 1 : -1
          );
          response.data.report.sort((a, b) =>
            a.username == b.username ? 0 : a.username > b.username ? 1 : -1
          );
        }
        
        response.data.report.map((item, index) => {
          let data = {};
          data["Datas"];
          data["Data"] = item.date;
          data["Modalidade"] = item.type;
          data["Id"] = item.driver_id;
          data["Entregador"] = item.driver;
          data["Estabelecimento"] = item.username;
          data["Endereço_de_entrega"] = item.arrival_address;
          data["Obs"] = item.note;
          data["Preço"] = convertValue(item.price);

          let isAdmin = window.localStorage.getItem('is_super_user') == 'true' ? true : false;
          if (isAdmin) {
            data["Pagamento"] = item.payment_form;
            data["Preço_TAXA"] = convertValue(item.price_without_tax);
          }

          if (selectAll == 2) {
            if (driverId == 0) {
              driverId = item.driver_id;
              allPriceDriver = allPriceDriver + item.price;
              allPriceNoTax = allPriceNoTax + item.price_without_tax;
            } 
            else if (driverId == item.driver_id) {
              allPriceDriver = allPriceDriver + item.price;
              allPriceNoTax = allPriceNoTax + item.price_without_tax;
            } 
            else {
              container.push("");
              allNamesAndPrice.push({
                Estabelecimento: "Pagamento atraves do PIX 38332651000151",
                Endereço_de_entrega: response.data.report[index - 1].driver + " Total: ",
                Preço: convertValue(allPriceDriver),
                Pagamento: "Total Motoqueiro: ",
                Preço_TAXA: convertValue(allPriceNoTax)
              });
              container.push({
                Estabelecimento: "Pagamento atraves do PIX 38332651000151",
                Endereço_de_entrega: response.data.report[index - 1].driver + " Total: ",
                Preço: convertValue(allPriceDriver),
                Pagamento: "Total Motoqueiro: ",
                Preço_TAXA: convertValue(allPriceNoTax),
              });
              allPriceDriver = 0 + item.price;
              allPriceNoTax = 0 + item.price_without_tax;
              driverId = item.driver_id;
              container.push("");
            }
          } 
          else if (selectAll == 1) {
            if (userId == 0) {
              userId = item.user_id;
              allPriceUser = allPriceUser + item.price;
              allPriceNoTaxUser = allPriceNoTaxUser + item.price_without_tax;
            } else if (userId == item.user_id) {
              allPriceUser = allPriceUser + item.price;
              allPriceNoTaxUser = allPriceNoTaxUser + item.price_without_tax;
            } else {
              container.push("");
              allNamesAndPrice.push({
                Estabelecimento: "Pagamento atraves do PIX 38332651000151",
                Endereço_de_entrega: response.data.report[index - 1].username + " Total: ",
                Preço: convertValue(allPriceUser),
                Pagamento: "Total Motoqueiro: ",
                Preço_TAXA: convertValue(allPriceNoTaxUser),
              });
              container.push({
                Estabelecimento: "Pagamento atraves do PIX 38332651000151",
                Endereço_de_entrega:
                  response.data.report[index - 1].username + " Total: ",
                Preço: convertValue(allPriceUser),
                Pagamento: "Total Motoqueiro: ",
                Preço_TAXA: convertValue(allPriceNoTaxUser),
              });
              allPriceUser = 0 + item.price;
              allPriceNoTaxUser = 0 + item.price;
              userId = item.user_id;
              container.push("");
            }
          } 
          else {
            allPrice = allPrice + item.price;
            finalAllPriceNoTax = finalAllPriceNoTax + item.price_without_tax;
          }
          container.push(data);
        });
        
        if (selectAll == 2) {
          container.push("");
          allNamesAndPrice.push({
            Estabelecimento: "Pagamento atraves do PIX 38332651000151",
            Endereço_de_entrega:
              response.data.report[response.data.report.length - 1].driver +
              " Total: ",
            Preço: convertValue(allPriceDriver),
            Pagamento: "Total Motoqueiro: ",
            Preço_TAXA: convertValue(allPriceNoTax)
          });
          container.push({
            Estabelecimento: "Pagamento atraves do PIX 38332651000151",
            Endereço_de_entrega:
              response.data.report[response.data.report.length - 1].driver +
              " Total: ",
            Preço: convertValue(allPriceDriver),
            Pagamento: "Total Motoqueiro: ",
            Preço_TAXA: convertValue(allPriceNoTax),
          });
          allPriceDriver = 0;
          allPriceNoTax = 0;
          driverId = 0;
          container.push("");
        } 
        else if (selectAll == 1) {
          container.push("");
          allNamesAndPrice.push({
            Estabelecimento: "Pagamento atraves do PIX 38332651000151",
            Endereço_de_entrega:
              response.data.report[response.data.report.length - 1].username +
              " Total: ",
            Preço: convertValue(allPriceUser),
            Pagamento: "Total Motoqueiro: ",
            Preço_TAXA: convertValue(allPriceNoTaxUser)
          });
          container.push({
            Estabelecimento: "Pagamento atraves do PIX 38332651000151",
            Endereço_de_entrega:
              response.data.report[response.data.report.length - 1].username +
              " Total: ",
            Preço: convertValue(allPriceUser),
            Pagamento: "Total Motoqueiro: ",
            Preço_TAXA: convertValue(allPriceNoTaxUser),
          });
          allPriceUser = 0;
          allPriceNoTaxUser = 0;
          userId = 0;
          container.push("");
        } 
        else {
          container.push("");
          
          let isAdmin = window.localStorage.getItem('is_super_user') == 'true' ? true : false;
          if (isAdmin) {
            allNamesAndPrice.push({
              Estabelecimento: "Pagamento atraves do PIX 38332651000151",
              Endereço_de_entrega: response.data.report[response.data.report.length - 1].username + " Total: ",
              Preço: convertValue(allPrice),
              Pagamento: "Total Motoqueiro: ",
              Preço_TAXA: convertValue(finalAllPriceNoTax)
            });
            container.push({
              Estabelecimento: "Pagamento atraves do PIX 38332651000151",
              Endereço_de_entrega: response.data.report[response.data.report.length - 1].username + " Total: ",
              Preço: convertValue(allPrice),
              Pagamento: "Total Motoqueiro: ",
              Preço_TAXA: convertValue(finalAllPriceNoTax),
            });
          } 
          else if (user_id != 0 && driver_id == 0) {
            allNamesAndPrice.push({
              Estabelecimento: "Pagamento atraves do PIX 38332651000151",
              Endereço_de_entrega: response.data.report[response.data.report.length - 1].username + " Total: ",
              Preço: convertValue(allPrice),
              //Pagamento: "Total Motoqueiro: ",
              //Preço_TAXA: convertValue(finalAllPriceNoTax)
            });
            container.push({
              Estabelecimento: "Pagamento atraves do PIX 38332651000151",
              Endereço_de_entrega: response.data.report[response.data.report.length - 1].username + " Total: ",
              Preço: convertValue(allPrice),
              //Pagamento: "Total Motoqueiro: ",
              //Preço_TAXA: convertValue(finalAllPriceNoTax),
            });
          } 
          else if (user_id == 0 && driver_id != 0) {
            allNamesAndPrice.push({
              Estabelecimento: "Pagamento atraves do PIX 38332651000151",
              Endereço_de_entrega: response.data.report[response.data.report.length - 1].driver + " Total: ",
              Preço: convertValue(allPrice),
              Pagamento: "Total Motoqueiro: ",
              Preço_TAXA: convertValue(finalAllPriceNoTax)
            });
            container.push({
              Estabelecimento: "Pagamento atraves do PIX 38332651000151",
              Endereço_de_entrega: response.data.report[response.data.report.length - 1].driver + " Total: ",
              Preço: convertValue(allPrice),
              Pagamento: "Total Motoqueiro: ",
              Preço_TAXA: convertValue(finalAllPriceNoTax),
            });
          } 
          else if (user_id != 0 && driver_id != 0) {
            allNamesAndPrice.push({
              Estabelecimento: "Pagamento atraves do PIX 38332651000151",
              Endereço_de_entrega: response.data.report[response.data.report.length - 1].driver + " Total: ",
              Preço: convertValue(allPrice),
              Pagamento: "Total Motoqueiro: ",
              Preço_TAXA: convertValue(finalAllPriceNoTax)
            });
            container.push({
              Estabelecimento: "Pagamento atraves do PIX 38332651000151",
              Endereço_de_entrega: response.data.report[response.data.report.length - 1].driver + " Total: ",
              Preço: convertValue(allPrice),
              Pagamento: "Total Motoqueiro: ",
              Preço_TAXA: convertValue(finalAllPriceNoTax),
            });
          } else {
            container.push({
              Estabelecimento: "Pagamento atraves do PIX 38332651000151",
              Endereço_de_entrega: "Total: ",
              Preço: convertValue(allPrice),
              Pagamento: "Total Motoqueiro: ",
              Preço_TAXA: 456 //convertValue(finalAllPriceNoTax),
            });
          }
        }
        
        container.push("");

        if ( selectAll == 2 || (user_id != 0 && driver_id != 0) || (user_id == 0 && driver_id != 0) ) {
          let testPrice = 0;
          allNamesAndPrice.map((item) => {
            testPrice = convertValue(item.Preço);
            testPrice = testPrice - (testPrice * 10) / 100;
            container.push({
              Endereço_de_entrega: item.Endereço_de_entrega,
              Obs: convertValue(item.Preço),
              Pagamento: "Total Motoqueiro: ",
              Preço_TAXA: convertValue(item.Preço_TAXA),
            });
          });
          container.push("");
          container.push({
            Estabelecimento: "Pagamento atraves do PIX 38332651000151",
            Endereço_de_entrega: "Totalizador: ",
            Obs: convertValue(totalList),
            Pagamento: "Total Motoqueiro: ",
            Preço_TAXA: convertValue(totalTaxList),
          });
        } 
        else if ( selectAll == 1 || (user_id != 0 && driver_id != 0) || (user_id != 0 && driver_id == 0) ) {
          let testPrice = 0;
          let allEstablishmentPrice = 0;
          allNamesAndPrice.map((item) => {
            testPrice = convertValue(item.Preço);
            (allEstablishmentPrice = allEstablishmentPrice + testPrice),
              container.push({
                Endereço_de_entrega: item.Endereço_de_entrega,
                Preço: convertValue(item.Preço),
              });
          });
          container.push("");
          container.push({
            Estabelecimento: "Pagamento atraves do PIX 38332651000151",
            Obs: "Totalizador: ",
            Preço: convertValue(totalList),
          });
        }

        var headers = Object.keys(container[0]);
        var ws = XLSX.utils.json_to_sheet(container, {
          header: headers,
        });

        /* add to workbook */
        var wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Financial Report");

        /* generate an XLSX file */
        XLSX.writeFile(
          wb,
          "Relatório financeiro  " +
            moment(new Date()).format("DD/MM/YYYY") +
            ".xlsx"
        );
      })
      .catch((error) => console.error(error));
  }

  function handleList(params) {
    let data = { start_time, end_time, status, driver_id, user_id, form_payment };
    const url =
      constants().URL_SERVICE +
      "establishment/establishment/get_report_financial/";

    setShowLoading(true);
    Axios.post(url, data, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {

        setShowLoading(false);
        setPaymentSolicitation(response.data.report);
        let allPriceList = 0;
        let allItemsList = 0;
        let allTaxPriceList = 0;
        response.data.report.map((item) => {
          allPriceList = allPriceList + item.price;
          allTaxPriceList = allTaxPriceList + item.price_without_tax;
          allItemsList = allItemsList + 1;
        });
        setAllItems(allItemsList);
        setTotalList(allPriceList);
        setTotalTaxList(allTaxPriceList);
      })
      .catch((error) => this.setState({ error: true }));
  }

  function handleDelete(params) {
    if (localStorage.is_super_user == "false") {
      setDriver_id("");
      setAllDriversValue("");
    } else {
      setDriver_id("");
      setUser_id("");
      setAllDriversValue("");
      setAllEstablishmentsValue("");
    }
  }

  function handleExportDocument() {}

  function exportReportPDF() {
    let data = {
      start_time,
      end_time,
      status,
      displayDate,
      date: moment().format("DD/MM/YYYY"),
      time: moment().format("LT"),
    };
    const url = "https://super-image-api.herokuapp.com/all-fast-report/";

    setShowLoading(true);

    Axios.post(url, data, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {
        // setShowLoading(false);
        // var win = window.open(response.data.path);
        // win.focus();
        setShowLoading(false);
        const el = document.createElement("div");
        el.innerHTML = `<a target="_blank" class="btn btn-primary" href='${response.data.path}'>Clique aqui para baixar o relatório em formato PDF.</a>`;

        swal({
          title: "Relatório de pagamento",
          content: el,
        });
      })
      .catch((error) => {
        setShowLoading(false);
        this.setState({ error: true });
      });
  }

  return (
    <div>
      <BarTitle name="Relatórios Financeiro" />
      <div className="padder padder-top-30 ">
        <Painel className="">
          <div class="reports-search-painel">
            <div>
              <span className="sub-title">Período</span>
              <DateRangePicker
                  initialSettings={initialSettingsDatePicker}
                  onEvent={handleEvent}
              >
                <input type="text" className="form-control data-input"/>
              </DateRangePicker>
            </div>

            <div>
              {localStorage.is_super_user == "true" ? (
                  <div>
                    <div className="sub-title">Estabelecimento</div>
                    {selectAll == 0 ? (
                        <ReactAutocomplete
                            items={allEstablishments}
                            shouldItemRender={(item, value) =>
                                item.label.toLowerCase().indexOf(value.toLowerCase()) >
                                -1
                            }
                            getItemValue={(item) => item.label}
                            renderItem={(item, highlighted) => (
                                <div
                                    key={item.id}
                                    style={{
                                      backgroundColor: highlighted
                                          ? "#eee"
                                          : "transparent",
                                    }}
                                >
                                  {item.label}
                                </div>
                            )}
                            value={allEstablishmentValue}
                            onChange={(e) => {
                              setAllEstablishmentsValue(e.target.value);
                            }}
                            onSelect={(value, item) => {
                              setAllEstablishmentsValue(value),
                                  setUser_id(item.id)
                            }}
                        />
                    ) : null}
                    <div class="checkbox-section">
                      <input
                          checked={selectAll.includes(1)}
                          onChange={() => {
                            if (selectAll.includes(1)) {
                              setSelectAll(selectAll.filter((item) => item !== 1));
                            } else {
                              setDriver_id("");
                              setUser_id("");
                              setAllDriversValue("");
                              setAllEstablishmentsValue("");
                              setSelectAll([1]);
                            }
                          }}
                          type="checkbox"
                      />
                      <label for="outsidebar">Todos os Estabelecimentos</label>
                    </div>
                  </div>
              ) : null}
            </div>

            <div>
              <div className="sub-title">Entregador</div>
              {selectAll == 0 ? (
                  <ReactAutocomplete
                      items={allDrivers}
                      shouldItemRender={(item, value) =>
                          item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
                      }
                      getItemValue={(item) => item.label}
                      renderItem={(item, highlighted) => (
                          <div
                              key={item.id}
                              style={{
                                backgroundColor: highlighted ? "#eee" : "transparent",
                              }}
                          >
                            {item.label}
                          </div>
                      )}
                      value={allDriversValue}
                      onChange={(e) => {
                        setAllDriversValue(e.target.value);
                      }}
                      onSelect={(value, item) => {
                        setAllDriversValue(value),
                            setDriver_id(item.id)
                      }}
                  />
              ) : null}


              <div class="checkbox-section">
                {localStorage.is_super_user == true ? (
                    <input
                        checked={selectAll.includes(2)}
                        onChange={() => {
                          if (selectAll.includes(2)) {
                            setSelectAll(selectAll.filter((item) => item !== 2));
                          } else {
                            setDriver_id("");
                            setUser_id("");
                            setAllDriversValue("");
                            setAllEstablishmentsValue("");
                            setSelectAll([2]);
                          }
                        }}
                        type="checkbox"
                    />
                ) : (
                    <input
                        checked={selectAll.includes(2)}
                        onChange={() => {
                          if (localStorage.is_super_user == "false") {
                            if (selectAll.includes(2)) {
                              setSelectAll(selectAll.filter((item) => item !== 2));
                            } else {
                              setSelectAll([2]);
                              setDriver_id("");
                            }
                          } else {
                            if (selectAll.includes(2)) {
                              setSelectAll(selectAll.filter((item) => item !== 2));
                            } else {
                              setSelectAll([2]);
                              setDriver_id("");
                              setUser_id("");
                            }
                          }
                        }}
                        type="checkbox"
                    />
                )}
                <label for="outsidebar">Todos os Entregadores</label>
              </div>
            </div>

            <div>
              <div className="sub-title">Forma de Pagamento</div>
              <select
                  onChange={(e) => {
                    setForm_payment(e.target.value);
                  }}
                  className="col-md-12 form-control">
                <option value="">Selecione a forma</option>
                <option value="0">Dinheiro</option>
                <option value="1">Crédito</option>
                <option value="2">Fidelidade</option>
              </select>
            </div>

            <div>
              <div className="sub-title">Status</div>
              <div class="checkbox-section">
                <input
                    type="checkbox"
                    checked={status.includes(4)}
                    onChange={() => {
                      if (status.includes(4)) {
                        setStatus(status.filter((item) => item !== 4));
                      } else {
                        setStatus([...status, 4]);
                      }
                    }}
                />
                <label for="outsidebar">Finalizado</label>
              </div>
              <div class="checkbox-section">
                <input
                    checked={status.includes(6)}
                    onChange={() => {
                      if (status.includes(6)) {
                        setStatus(status.filter((item) => item !== 6));
                      } else {
                        setStatus([...status, 6]);
                      }
                    }}
                    type="checkbox"
                />
                <label for="outsidebar">Recusado</label>
              </div>
              <div class="checkbox-section">
                <input
                    checked={status.includes(1)}
                    onChange={() => {
                      if (status.includes(1)) {
                        setStatus(status.filter((item) => item !== 1));
                      } else {
                        setStatus([...status, 1]);
                      }
                    }}
                    type="checkbox"
                />
                <label for="outsidebar">Pendente</label>
              </div>
              <div class="checkbox-section">
                <input
                    type="checkbox"
                    checked={status.includes(5)}
                    onChange={() => {
                      if (status.includes(5)) {
                        setStatus(status.filter((item) => item !== 5));
                      } else {
                        setStatus([...status, 5]);
                      }
                    }}
                />
                <label for="outsidebar">Cancelado</label>
              </div>
            </div>
            <div>
              <a onClick={handleDelete} type="button" class="btn btn-danger">
                Excluir
              </a>
              <br/>
              <a
                  style={{marginTop: "20%"}}
                  onClick={() => {
                    handleList();
                  }}
                  type="button"
                  class="btn btn-info"
              >
                Listar
              </a>
              <br/>
              {paymentSolicitation.length > 0 && (
                  <a
                      style={{marginTop: "20%"}}
                      type="button"
                      class="btn btn-success"
                      onClick={handleGetFinancials}
                  >
                    Gerar
                  </a>
              )}
            </div>
          </div>
        </Painel>
      </div>
      {/* <div className="padder">
      <Painel title="Dados do cliente / Dados solicitação pagamento" />
    </div> */}
      <div className="padder">
        <Painel title="Dados do cliente / Dados solicitação pagamento">
          <div className="table-wrap">
            <table className="table table-striped">
              <thead>
                {!showLoading && paymentSolicitation.length > 0 && (
                  <tr>
                    <th style={{ marginLeft: "20%" }}>Id</th>
                    <th>Dados</th>
                    <th>
                      Descrição: / Total: R$
                      {totalList.toLocaleString("pt-br", {
                        minimumFractionDigits: 2,
                      })}{" "}
                      / Total de Pedidos: {allItems.toLocaleString("pt-br")}
                    </th>
                    <th>Status</th>
                  </tr>
                )}
              </thead>
              <tbody>
                {!showLoading &&
                  paymentSolicitation.map((solicition, i) => {
                    return (
                      <tr>
                        <td
                          style={{
                            marginLeft: "20%",
                            display: "flex",
                            flexDirection: "row",
                            alignSelf: "center",
                            fontSize: "16pt",
                          }}
                        >
                          {i + 1}
                        </td>
                        <td>
                          <b>Data: </b>
                          {solicition.date}
                          <br />
                          <b>Modalidade: </b>
                          {solicition.type}
                          <br />
                          <b>Id: </b>
                          {solicition.driver_id}
                          <br />
                          <b>Entregador: </b>
                          {solicition.driver}
                          <br />
                          <b>Estabelecimento: </b>
                          {solicition.username}
                        </td>
                        <td>
                          <b>Observação: </b>
                          {solicition.note}
                          <br />
                          <b>Valor: </b>
                          {solicition.price.toLocaleString("pt-br", {
                            minimumFractionDigits: 2,
                          })}
                          <br />
                          <b>Endereço de Entrega: </b>
                          {solicition.arrival_address}
                          <br />
                          <b>Tipo: </b>
                          {solicition.payment_form}
                        </td>

                        <td>
                          {solicition.status == 1 ? (
                            <label className="label bg-warning m-l-xs">
                              Pendente
                            </label>
                          ) : null}

                          {solicition.status == 4 ? (
                            <label className="label bg-success m-l-xs">
                              Finalizado
                            </label>
                          ) : null}

                          {solicition.status == 6 ? (
                            <label className="label bg-danger m-l-xs">
                              Recusado
                            </label>
                          ) : null}
                          {solicition.status == 5 ? (
                            <label className="label bg-danger m-l-xs">
                              Cancelado
                            </label>
                          ) : null}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
              <div className="no-result">
                {paymentSolicitation.length == 0 && !showLoading && (
                  <h3>Nenhum resultado encontrado</h3>
                )}
                {showLoading && (
                  <img
                    width="25"
                    height="25"
                    src="https://static1.deway.com.br/allfast/loading-loading-forever.gif"
                  ></img>
                )}
              </div>
            </table>
          </div>
        </Painel>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/FinancialReports/index.js


// WEBPACK FOOTER //
// ./src/views/FinancialReports/index.js